module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsText":"No invoices to show."},"fi":{"noItemsText":"Laskuja ei löytynyt."},"sv":{"noItemsText":"Det finns inga fakturor att visa."}}')
  delete Component.options._Ctor
}
